import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostDownload } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const DocReviewExportAction = createAsyncThunk(
    "docReviewExport", async (arg, { rejectWithValue }) => {
        try {
            const resposnse = await doPostDownload(urls.entityListData, arg);
            return resposnse;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const DocReviewExportSlice = createSlice({
    name: "docReviewExport",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        docReviewExportReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [DocReviewExportAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [DocReviewExportAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [DocReviewExportAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})

export const { docReviewExportReset } = DocReviewExportSlice?.actions;